import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useFirstRender from '@swf/core/hooks/useFirstRender';
import type { Dispatch } from '@swf/core/store';

const useCheckSportsStatus = () => {
  const isFirstRender = useFirstRender();
  const dispatch = useDispatch<Dispatch>();

  useEffect(() => {
    if (isFirstRender) dispatch.system.check();
  }, [dispatch.system, isFirstRender]);
};

export default useCheckSportsStatus;
